var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon warning",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 129",
    d: "M7.119 3.78a2.364 2.364 0 0 1 4.23 0l5.632 11.269a2.365 2.365 0 0 1-2.115 3.423H3.6a2.365 2.365 0 0 1-2.115-3.423z",
    transform: "translate(-1.233 -2.472)",
    style: {
      fill: "#b51218"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 130",
    d: "m3.17-5.473.182-5.727H1.009l.182 5.727zm-.989 3.515A1.388 1.388 0 0 0 3.626-3.4a1.391 1.391 0 0 0-1.445-1.461A1.391 1.391 0 0 0 .736-3.4a1.388 1.388 0 0 0 1.445 1.442z",
    transform: "translate(5.819 16)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.267b75c2f5491ee78c40835585afb119.svg";
export { ForwardRef as ReactComponent };